// Shared "Reset layout" + "Apply layout" toolbar buttons, so every tabular
// interface (multi-tabular, list, child window, form-input) renders them
// identically and in the same toolbar slot (immediately before Refresh). They
// only appear once the user has dragged a column width/order AND the surface
// can persist into the design (author, non-site).

import { Columns3, Loader2 } from 'lucide-react'

export function LayoutActions({
  show, applying, onReset, onApply, applyLabel, applyTitle,
}: {
  show: boolean
  applying: boolean
  onReset: () => void
  onApply: () => void
  /** Override the "Apply" button wording — e.g. "Save to customization" when the
   *  surface persists into a per-tenant overlay rather than the design JSON. */
  applyLabel?: string
  applyTitle?: string
}) {
  if (!show) return null
  return (
    <>
      <button
        type="button" className="btn btn-ghost btn-sm"
        onClick={onReset}
        disabled={applying}
        title="Discard the column width / order changes made here"
      >Reset layout</button>
      <button
        type="button" className="btn btn-ghost btn-sm"
        onClick={onApply}
        disabled={applying}
        title={applyTitle ?? 'Save the new column widths & order into the transaction design'}
        style={{ color: 'var(--color-accent)' }}
      >
        {applying
          ? <Loader2 size={14} style={{ animation: 'spin 1s linear infinite' }} />
          : <Columns3 size={14} />} {applyLabel ?? 'Apply layout'}
      </button>
    </>
  )
}
